module.exports = __webpack_public_path__ + "static/media/logo.f3ad7664.svg";